import styled from 'styled-components';

export const Button = styled.button`
  cursor: pointer;
  /* position: absolute;
  top: 0px;
  right: 10px;
  height: 42px;
  width: 42px; */
  background-color: #47b972;
  background-image: linear-gradient(90deg, #5cc98a 0%, #3aa863 100%);
  border: 0;
  padding: 0;
  margin: 0;
  border-radius: 10px;
  width: 90px;
  height: 36px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 25px auto;
  box-shadow: 0 1px 2px rgba(16, 24, 32, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.16);

  img {
    max-height: 80%;
    width: auto;
  }
  transition: filter 0.15s ease-in;
  &:hover {
    /* box-shadow: 0 0 15px 1px rgba(0, 0, 0, 0.6); */
    filter: brightness(1.06);
  }
`;

export const ButtonCall = styled(Button)`
  background-image: url(/images/calls/call-start.svg), linear-gradient(90deg, #5cc98a 0%, #3aa863 100%);
  background-repeat: no-repeat, no-repeat;
  background-position: 60% center, center;
  background-size: 25px auto, cover;
`;

export const ButtonDrop = styled(Button)`
  background-image: url(/images/calls/call-end.svg), linear-gradient(90deg, #d8434f 0%, #cc2936 100%);
  background-repeat: no-repeat, no-repeat;
  background-position: center, center;
  background-size: 25px auto, cover;
  &:hover {
    filter: brightness(1.06);
  }
`;
